import { Card, Grid, Typography } from "@mui/material";
import {styled} from "@mui/material/styles";
import { useColors } from "../../Context/ColorsContext";
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, tablet, desktop } = MediaQuerys;

export const ContainerGraphics = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    height: '100%'
  }
})

export const ContainerCharts = styled(Card)(({ width, height }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        height: '150px',
        width: width,
        // padding: '10px',
        boxShadow: 'none',
        border: 'none',
        overflowX: 'auto !important',
        '&::-webkit-scrollbar': {
            height: '5px',
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
        } 
    }
});

export const ContainerGroup = styled('div')(() => {
  return {
    display: 'flex',
    width: '100%',
    gap: '1rem',
    flexDirection: 'row',
    [mobile]: {
      flexDirection: 'column',
    }
  }
})

export const ContainerCard = styled('div')(() => {
  return {
    width: '50%',
    [mobile]: {
      width: '100%',
    }
  }
})

export const GridCard = styled(Grid)(() => {
  const { colors } = useColors(); 
  return {
      background: colors.white,
      padding: 20,
      borderRadius: '8px',
      width: '100%',
      height: '100%',
      transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
  }
})

export const CustomTitleGraphics = styled(Typography)(() => {
    return {
      // marginLeft: '1rem',
      padding: 0,
      margin: '2px 0',
      fontWeight: 'bold',
      fontSize: '14px',
    }
})